
import React from "react"
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useEffect } from 'react';
import { setErrorMessage } from "../tools/errorhandling";
import hotelcss from './css/hotelhotellist.module.css';
import Timeline from 'react-calendar-timeline'
import HotelSelection from '../customNodes/HotelSelection';
import './css/TimeLine.scss'
import {
  getverlofaanvragen, gethotelcleaners, getholidaysbyid, getverlofaanvragenhotel_data
} from "../dbconnector/connector";
import moment from 'moment';
import HolidayRequestNode from '../customNodes/HolidayRequestNode';
import { use } from "react";
import { months } from "moment/moment";


const HolidayCalendar = (props) => {
  const t = props.translation
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);
  const [selectedhotel, setSetselectedhotel] = useState('');
  const [items, setItems] = useState([]);
  const [hotelcleaners, sethotelcleaners] = useState([]);
  const [holidays, setholidays] = useState([]);
  const [iconDisabled, setIconDisabled] = useState(false);
  const [selectedRecord, setselectedRecord] = useState([]);
  const [isDisabled, setisDisabled] = useState(false);

  const selectHotel = async (e) => {
    setSetselectedhotel(e.target.value)
    await GetHolidays(e.target.value, moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD'))
  }

  const GetHolidays = async (HotelId, date_start, date_end) => {
    setholidays([])
    if (HotelId) {
      await getverlofaanvragenhotel_data(HotelId, date_start, date_end).then(async res => {
        if (res.status === 200) {
          await res.json().then(res => {
            setholidays(res)
          })
        } else {
          setErrorMessage(res.statusText)
        }
      })
    }
  }
  function CheckHolidayofuser(userid) {
    var data = holidays.filter(item => item.werknemers_Id === userid)
    if (data.length > 0) {
      return data
    } else { return false }
  }

  useEffect(() => {
    setItems([])
    setGroups(hotelcleaners.map((item, index) => {
      const group = {
        id: item.id,
        title: item.achternaam + ", " + item.voornaam,
        stackItems: false
      }
      return group
    })
    )
  }, [holidays, hotelcleaners]);

  useEffect(() => {
    if (!isNaN(selectedhotel)) {
      var counter = 0;
      gethotelcleaners(selectedhotel).then(async res => {
        if (res.status === 200) {
          await res.json().then(res => {
            sethotelcleaners(res.items)
          })
        }
      })
    }
  }, [selectedhotel])

  useEffect(() => {
    setItems([])
    GetHotelCleaners()
  }, [hotelcleaners, groups]);

  const GetHotelCleaners = async () => {
    let items = []
    var counter = 0;
    if (hotelcleaners.length > 0) {
      hotelcleaners.forEach((item, index) => {
        const data = CheckHolidayofuser(item.id);
        if (data !== false) {
          data.forEach((aanvraag) => {
            counter += 1;
            let statuscolor = 'var(--requested)';
            if (aanvraag.status === 0) {
              statuscolor = 'var(--requested)'
            } else if (aanvraag.status === 1) {
              statuscolor = 'var(--approvedsup)'//requested
            } else if (aanvraag.status === 2) {
              statuscolor = 'var(--approved)'//requested
            } else if (aanvraag.status === 3) {
              statuscolor = 'var(--rejected)'
            }

            if (items.filter(item => item.id === aanvraag.id + aanvraag.startdatum + aanvraag.einddatum).length === 0) {
              items.push({
                id: aanvraag.id + aanvraag.startdatum + aanvraag.einddatum,
                group: item.id,
                start_time: moment(aanvraag.startdatum),//.add(2, 'day'),
                end_time: moment(aanvraag.einddatum).add(1, 'day'),
                canMove: false,
                
                itemProps: {
                  // these optional attributes are passed to the root <div /> of each item as <div {...itemProps} />
                  'data-custom-attribute': 'Random content',
                  'aria-hidden': true,
                  onMouseUp: () => { selectRecord(aanvraag) },
                  className: 'weekend',
                  style: {
                    background: statuscolor,

                  }
                }
              })
            }
          })

        }
      })
    }
    setItems(items);
  }

  const handleCancel = () => {
    document.getElementById("assignmentdetails").style.display = "none"
    document.getElementById("coverAll").style.display = "none"
  }

  function selectRecord(record) {

    if (record.status > 1 && props.rights === 3) {
      setisDisabled(true);
    } else { setisDisabled(false); }
    setselectedRecord(record)
    document.getElementById("coverAll").style.display = "block"
    document.getElementById("assignmentdetails").style.display = "block"
  }

  const handleitemchange = (e) => {
    setselectedRecord((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value
      }
    })
  }

  return (
    <>
      <div id="main">
        <header>
          <div id="errordiv" className='error'></div>
        </header>
        <div id="filters" className="form" >
          <label className='formtitleContentBox'>{t('filterinstellingen')}</label>
          <br></br>
          <div className="contentbox">
            <div id="searchbox" className="formElement">
              <label className='labelcolor'>
                {t('Hotel')}:
              </label>
              <HotelSelection id="hotelselection" isDisabled={false} data={{ fieldname: "hotel_id", selectedhotel: null, handleitemchange: selectHotel }} valueneeded="hotel_id" userhotels={props.rights === 2 ? false : true} />
            </div>
          </div>
        </div>
    
        <div id="content" className="calendardiv">
          <p className="calendartip">shift + mousewheel = move timeline left/right <br></br>alt + mousewheel = zoom in/out</p>
          <Timeline
            groups={groups}
            items={items}
            onZoom={null}
            buffer={3}
            className="calendarform"
            lineHeight={35}
            traditionalZoom={true}
            canResize={true}
            sidebarWidth={150}
            rightSidebarWidth={0}
            minZoom={604800000}
            // visibleTimeStart ={moment().add(-1, 'day')}
            // visibleTimeEnd = {moment().add(32, 'day')}
            defaultTimeStart={moment().startOf('year').add(-30, 'day')}
            defaultTimeEnd={moment().endOf('year').add(30, 'day')}
          />
        </div>
        <div id="coverAll" className="coverall">
          {/* ({ rights, t, disabled, data, events, css }) */}
          <HolidayRequestNode
            rights={props.rights}
            t={t}
            isDisabled={isDisabled}
            data={{ record: selectedRecord }}
            events={{ handleCancel: handleCancel, handleitemchange: handleitemchange, LoadRequests: GetHotelCleaners }}
            css={hotelcss}
          />
        </div>
      </div >
    </>
  )
}

export default HolidayCalendar